/**
 * Break-glass session banner (integration spec §E step 11).
 *
 * Requirements it satisfies, deliberately:
 *   - visible on **every** page while a local-admin session is active
 *   - **not dismissable** — an operator must never forget they're in a break-glass session and
 *     make changes believing them synchronised with Bedrock
 *   - states plainly that actions are not synchronised with Bedrock
 */

import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export function LocalAdminBanner({ appName }: { appName: string }) {
  return (
    <div
      role="status"
      className="sticky top-0 z-50 flex items-center justify-center gap-2 px-4 h-10 bg-amber-500 dark:bg-amber-600 text-white text-sm font-medium"
    >
      <ExclamationTriangleIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="text-center">
        Signed in as {appName} local admin. This is a break-glass session — your actions are not
        synchronised with Bedrock.
      </span>
    </div>
  );
}
